/**
 * Escape a URL for safe interpolation inside a CSS `url("...")` value.
 * Prevents CSS injection when a persisted URL contains quotes, backslashes, or newlines.
 */
export default function escapeCssUrl(url) {
  if (url == null) return '';
  return String(url)
    .replace(/\\/g, '\\\\')
    .replace(/"/g, '\\"')
    .replace(/\n/g, '\\A ');
}
